export default "__VITE_ASSET__DYEDmwRC__"